import classNames from 'classnames';
import { SvgIconComponent } from '../types/svgs';

const UpdateButton: React.FC<{
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  IconComponent?: SvgIconComponent;
  theme: 'green' | 'orange' | 'blue' | 'red' | 'neutral';
  text: string;
  className?: string;
  ariaLabel?: string;
}> = ({ onClick, IconComponent, theme, text, className, ariaLabel }) => {
  const icon = IconComponent && (
    <IconComponent
      className={classNames(
        'mr-1.5 h-3.5 min-h-[14px] w-3.5 min-w-[14px] flex-shrink-0',
        theme === 'neutral' && 'text-green-125',
        theme === 'orange' && 'text-orange-150',
        theme === 'green' && 'text-secondary-200',
        theme === 'blue' && 'text-blue-150',
        theme === 'red' && 'text-neutral-150',
      )}
    />
  );

  return (
    <button
      className={classNames(
        'mr-2 flex items-center rounded-full py-1.5 px-2.5 pr-3 text-center text-small-caption focus:outline-secondary-100',
        theme === 'neutral' && 'bg-green-20 text-green-125 hover:bg-green-25',
        theme === 'green' &&
          'bg-secondary-20 text-secondary-150 hover:bg-secondary-25',
        theme === 'orange' && 'bg-orange-25 text-orange-150 hover:bg-orange-50',
        theme === 'blue' && 'bg-blue-25/60 text-blue-150 hover:bg-blue-25',
        theme === 'red' && 'bg-red-25 text-neutral-150 hover:bg-red-50/60',
        className,
      )}
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      {icon}
      <div className="line-clamp-2">{text}</div>
    </button>
  );
};

export default UpdateButton;
